/* Lotus Wheel "sessions" chart — animates when scrolled into view.
   Cells fill one-by-one (CSS stagger via --i), numbers count up from 0.
   Progressive enhancement: without JS the final state is already rendered;
   skipped entirely under prefers-reduced-motion. */
class ReasonChart extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.counters = Array.from(this.querySelectorAll('[data-countup]'));
    // Hide cells for the pre-animation state only now that JS will run.
    this.classList.add('sessions-chart--anim');

    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.play();
          this.observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    this.observer.observe(this);
  }

  play() {
    this.classList.add('is-visible');
    this.counters.forEach((el) => this.countUp(el));
  }

  countUp(el) {
    const target = parseInt(el.dataset.countup, 10);
    if (Number.isNaN(target)) return;
    const duration = 900;
    const start = performance.now();
    el.textContent = '0';
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target).toString();
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = String(target);
    };
    requestAnimationFrame(tick);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('reason-chart', ReasonChart);
